module.exports = __webpack_public_path__ + "static/img/banner_home.4cf7ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC/banner_home.png
// module id = VdxG
// module chunks = 1